import classNames from "classnames/bind";
import styles from './Header.module.scss';
import {NavLink, Link } from 'react-router-dom';
import {useAssetsImage} from  '~/pages/context/AssetsImageContext';
import LanguageSwitcher from  '../LanguageSwitcher'
const cx = classNames.bind(styles);
const navItems = [
    { to: "/home", label: "Home" },
    { to: "/about-us", label: "About us" },
    { to: "/our-service", label: "Service" },
    { to: "/appointment", label: "Appointment" },
    { to: "/article", label: "Article" },
    { to: "/pricing", label: "Pricing" },
    { to: "/terms-condition", label: "Term-condition" },
];
function Header(){
    const {getImageUrlById} = useAssetsImage();
    const handleChangeTitle = (title) => {
        document.title = "BreakThrough: " + title;
    }
    return (
        <div className="bg-body-emphasis sticky-top shadow-lg" data-navbar-shadow-on-scroll="data-navbar-shadow-on-scroll">
            <nav className="navbar navbar-expand-lg container-medium">
                <Link className="navbar-brand flex-1 flex-lg-grow-0" to="/home">
                    <div className="d-flex align-items-center">
                        {
                            getImageUrlById(39) &&
                            <img src={getImageUrlById(39)} alt="breakthrough" width="50"/>
                        }
                    </div>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="true" aria-label="Toggle navigation"><span
                    className="navbar-toggler-icon"></span></button>
                <div className="navbar-collapse collapse show" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {navItems.map((item) => (
                            <li key={item.to} className="nav-item border-bottom border-translucent border-bottom-lg-0">
                                <NavLink
                                    className={({ isActive }) =>
                                        cx(
                                            "nav-link-item",
                                            "nav-link lh-1 py-0 fs-9 fw-bold py-3",
                                            { "text-danger": isActive }
                                        )
                                        }
                                        to={item.to}
                                        onClick={() => handleChangeTitle(item.label)}
                                >
                                    {item.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="d-grid d-lg-flex align-items-center">
                        <Link className="btn btn-bt-primary order-0 me-3" to="/ai-chatbot" target="_blank">
                            <span className="fw-bold">AI Chatbot</span>
                        </Link>
                        <LanguageSwitcher/>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Header;